import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

function SearchTileAmenitiesLoadingSkeleton() {
  return <VerticalSpacer gap={4}>
    <TextLoadingBox typography="body-small" width="60%" />
    <TextLoadingBox typography="body-small" width="80%" />
    <TextLoadingBox typography="body-small" width="40%" />
  </VerticalSpacer>
}

export default SearchTileAmenitiesLoadingSkeleton
